import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { assoc, compose, pick } from 'ramda'

export const cleanRequest = item => {
  const critic = item.value.critic > 0 ? parseInt(item.value.critic) : null
  const warning = item.value.warning > 0 ? parseInt(item.value.warning) : null

  let normalCondition = { id: 'normal', label: 'Normal', lt: warning || critic }

  let warningCondition = { id: 'warning', label: 'Atenção', gte: warning, color: 'darkYellow' }
  if (!!critic) warningCondition.lt = critic
  if (!warning) warningCondition = null
  let criticCondition = { id: 'critic', label: 'Crítico', gte: critic, color: 'red' }
  if (!critic) criticCondition = null

  let value = [
    ...appendIf(normalCondition, normalCondition), //
    ...appendIf(warningCondition, warningCondition), //
    ...appendIf(criticCondition, criticCondition) //
  ]

  if (!critic && !warning) value = []

  return compose(
    pick(['id', 'name', 'value']), //
    assoc('value', JSON.stringify(value))
  )(item)
}
